import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box, CircularProgress } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Documentation from './pages/Documentation';
import BusinessTypes from './pages/BusinessTypes';
import Plans from './pages/Plans';
import Shops from './pages/Shops';
import Users from './pages/Users';
import MasterData from './pages/MasterData';
import PlatformLineSettings from './pages/PlatformLineSettings';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2196F3',
    },
    secondary: {
      main: '#FF9800',
    },
  },
});

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, adminData, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser || !adminData) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        {/* /admin の下に置くので basename を通す。
            指定しないと直接開いたURLがルーターに届かず白い画面になる。 */}
        <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/documentation"
              element={
                <PrivateRoute>
                  <Layout>
                    <Documentation />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/business-types"
              element={
                <PrivateRoute>
                  <Layout>
                    <BusinessTypes />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/plans"
              element={
                <PrivateRoute>
                  <Layout>
                    <Plans />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/shops"
              element={
                <PrivateRoute>
                  <Layout>
                    <Shops />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <Layout>
                    <Users />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/master-data"
              element={
                <PrivateRoute>
                  <Layout>
                    <MasterData />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/platform-line"
              element={
                <PrivateRoute>
                  <Layout>
                    <PlatformLineSettings />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
